export const FORMATO_RETRO_COMERCIAL = 2

export const PREGUNTAS_GENERALES = [
  { key: 'p1', texto: '¿Mantiene un tono de voz adecuado y profesional?' },
  { key: 'p2', texto: '¿Su tiempo de respuesta es oportuno?' },
  { key: 'p4', texto: '¿Es ágil en la atención de sus contactos?' },
  { key: 'p5', texto: '¿Mantiene contactos pendientes o en espera?' },
  { key: 'p6', texto: '¿Se comunica de manera formal y cordial con los prospectos?' },
  { key: 'p7', texto: '¿Mantiene organizada su bandeja de entrada?' },
]

export const PREGUNTAS_SEGUIMIENTO = [
  { key: 'valor1', texto: '¿Identifica las necesidades del prospecto?' },
  { key: 'valor2', texto: '¿El tiempo de respuesta es adecuado?' },
  { key: 'valor3', texto: '¿Personaliza sus mensajes y audios?' },
  { key: 'valor4', texto: '¿Presenta una propuesta de valor?' },
  { key: 'valor5', texto: '¿Maneja correctamente las objeciones?' },
  { key: 'valor6', texto: '¿Realiza un segundo seguimiento cuando corresponde?' },
  { key: 'valor7', texto: '¿La conversación avanza hacia una inscripción?' },
  { key: 'valor8', texto: '¿Propone un siguiente paso concreto para continuar con el proceso?' },
]

export function esFormatoComercial (item) {
  return Number(item && item.formato) === FORMATO_RETRO_COMERCIAL
}

/** Calificación 0-100 redondeada a partir del `promedio` que calcula la API. */
export function calificacionRetro (item) {
  const valor = parseFloat(item && item.promedio)
  return isNaN(valor) ? null : Math.round(valor)
}

/** Mismos cortes que las etiquetas de la API (Bueno ≥ 14/17, Regular ≥ 11/17). */
export function formatoMinutosRetro (minutos) {
  if (minutos === null || minutos === undefined) return '—'
  const valor = Math.round(Number(minutos))
  if (valor < 60) return valor + ' min'
  return Math.floor(valor / 60) + ' h ' + (valor % 60) + ' min'
}

export function textoPeriodoHallazgos (hallazgos) {
  const inicio = String(hallazgos.fecha_inicio || hallazgos.semana_inicio).slice(0, 10)
  const fin = String(hallazgos.fecha_fin || hallazgos.semana_fin).slice(0, 10)
  return inicio === fin ? 'Del ' + inicio : 'Del ' + inicio + ' al ' + fin
}

export function colorCalificacionRetro (calificacion) {
  if (calificacion === null || calificacion === undefined) return 'grey'
  if (calificacion >= 82) return 'green'
  if (calificacion >= 65) return 'orange'
  return 'red'
}
